import jhBaseFlowLayout from '../components/baseFlowLayout/index.vue';

export default {
  jhBaseFlowLayout
};
